import CustomCell from './Cell';

export default CustomCell;



// WEBPACK FOOTER //
// ./src/pages/universalDetails/niinDetailTables/subcomponents/CustomItemCell/index.jsx